import { QueryStatus } from 'src/types'
import { useEffect, useState } from 'react'
import {CLFBDetalle} from "../types/types";
import {HttpCLFB} from "../api/HttpCLFB";

export const useDetalleCLFB = (idOperacion: number) => {
    const [detalles, setDetalles] = useState<CLFBDetalle[]>()
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)

    const fetch = () => {
        setStatus(QueryStatus.Loading)

        HttpCLFB.getDetalle(idOperacion)
            .then(value => {
                setDetalles(value)
                setStatus(QueryStatus.Success)
            })
            .catch(e => {
                setStatus(QueryStatus.Error)
                console.log(e)
            })
    }

    const refetch = () => fetch()


    useEffect(() => {
        fetch()
    }, [idOperacion])

    return { detalles, refetch, status}
}
